import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import { isLoggedIn, removeToken } from "../services/CookieHandler";

export const DesktopSideNav: FC = () => {
  const location = useLocation();
  const [legalMenuOpened, setLegalMenuOpened] = useState(false);

  const sideMenus = [
    { label: "画像生成", href: "/image-generation", icon: "/images/icon/icons8-add-new-500.png" },
    { label: "動画生成", href: "/video-generation", icon: "/images/icon/camera.jpg" },
    { label: "インスピ", href: "/inspiration", icon: "/images/icon/icons8-gallery-512.png" },
    { label: "生成履歴", href: "/generation-history", icon: "/images/icon/icons8-gallery-480.png" },
    { label: "アカウント", href: "/account", icon: "/images/icon/icons8-male-user-512.png" },
    { label: "お支払い", href: "/subscription", icon: "/images/icon/icons8-wallet-500.png" },
  ];

  const sideUtilities = [
    { label: "プラン", href: "/plan", icon: "/images/icon/icons8-lightning.png" },
    { label: "ヘルプ", href: "/article/help", icon: "/images/icon/icons8-help-500.png" },
    { label: "利用規約", href: "/terms-of-service", icon: "/images/icon/icons8-document-500.png" },
  ];

  function logout() {
    removeToken();
    window.location.href = "/image-generation";
  }

  return (
    <aside className="hidden sm:flex shrink-0 w-[76px] h-[calc(100vh-76px)] sticky top-[76px] overflow-visible relative z-[200] justify-center">
      <div className="w-[56px] h-full pt-4 flex flex-col overflow-visible">
        {sideMenus.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <a key={item.href} href={item.href} className="flex justify-center mb-1.5">
              <div
                className={`rounded-xl w-12 h-[56px] flex flex-col items-center justify-center ${isActive ? "bg-[#F3F5FF]" : "hover:bg-[#F7F8FC]"}`}
                title={item.label}
              >
                <img src={item.icon} className="w-5 h-5" alt={item.label} />
                <span className={`w-full text-center mt-0.5 text-[9px] leading-none whitespace-nowrap ${isActive ? "text-[#0000F3]" : "text-[#8A8FA3]"}`}>{item.label}</span>
              </div>
            </a>
          );
        })}

        <div className="mt-auto pb-4">
          {sideUtilities.map((item) => {
            const isActive = location.pathname === item.href;
            const isDocumentIcon = item.label === "利用規約";
            return (
              <div
                key={item.href}
                className="relative flex justify-center"
                onMouseEnter={() => {
                  if (isDocumentIcon) setLegalMenuOpened(true);
                }}
                onMouseLeave={() => {
                  if (isDocumentIcon) setLegalMenuOpened(false);
                }}
              >
                {isDocumentIcon ? (
                  <div
                    className={`rounded-xl w-12 h-12 flex flex-col items-center justify-center ${isActive ? "bg-[#F3F5FF]" : "hover:bg-[#F7F8FC]"}`}
                    title={item.label}
                  >
                    <img src={item.icon} className="w-6 h-6" alt={item.label} />
                  </div>
                ) : (
                  <a href={item.href} className="flex justify-center mb-1.5">
                    <div
                      className={`rounded-xl w-12 ${item.label === "プラン" ? "h-[56px]" : "h-12"} flex flex-col items-center justify-center ${isActive ? "bg-[#F3F5FF]" : "hover:bg-[#F7F8FC]"}`}
                      title={item.label}
                    >
                      <img src={item.icon} className="w-6 h-6" alt={item.label} />
                      {item.label === "プラン" && (
                        <span className={`w-full text-center mt-0.5 text-[9px] leading-none whitespace-nowrap ${isActive ? "text-[#0000F3]" : "text-[#8A8FA3]"}`}>プラン</span>
                      )}
                    </div>
                  </a>
                )}
                {isDocumentIcon && legalMenuOpened && (
                  <div className="absolute left-[56px] bottom-0 z-[120] min-w-[220px] w-max rounded-lg border border-[#E5E7F0] bg-white shadow-[0_8px_24px_rgba(0,0,0,0.12)] py-2 pointer-events-auto">
                    <a href="/terms-of-service" className="block px-3 py-1.5 text-[12px] text-[#3A3F54] hover:bg-[#F7F8FC]">利用規約</a>
                    <a href="/privacy-policy" className="block px-3 py-1.5 text-[12px] text-[#3A3F54] hover:bg-[#F7F8FC]">プライバシーポリシー</a>
                    <a href="/commercial-transactions" className="block px-3 py-1.5 text-[12px] text-[#3A3F54] hover:bg-[#F7F8FC]">特定商取引法に基づく表示</a>
                    <a href="/about-model" className="block px-3 py-1.5 text-[12px] text-[#3A3F54] hover:bg-[#F7F8FC]">モデルテイストについて</a>
                    <a href="/company" className="block px-3 py-1.5 text-[12px] text-[#3A3F54] hover:bg-[#F7F8FC]">運営会社</a>
                    <a href="/contact" className="block px-3 py-1.5 text-[12px] text-[#3A3F54] hover:bg-[#F7F8FC]">お問い合わせ</a>
                  </div>
                )}
              </div>
            );
          })}
          {isLoggedIn() && (
            <button
              type="button"
              onClick={logout}
              className="w-12 h-12 mx-auto mt-1 rounded-xl hover:bg-[#F7F8FC] flex items-center justify-center clickable"
              aria-label="ログアウト"
              title="ログアウト"
            >
              <img src="/images/icon/icons8-logout-500.png" className="w-6 h-6" alt="ログアウト" />
            </button>
          )}
        </div>
      </div>
    </aside>
  );
};
